export default "__VITE_PUBLIC_ASSET__74acb88f__"